<template>
  <div class="baiduQueue">
    <div class="btn">
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="openAddForm">新增类型</el-button>
        </el-button-group>
      </div>
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="refreshList">刷新</el-button>
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <industry-list
        ref="industryList"
        @add-child="openChildDialog"
        @edit="openEditForm"
      ></industry-list>
    </div>

    <el-dialog
      :title="form.id ? '编辑类型' : '新增类型'"
      :visible.sync="formVisible"
      width="500px"
      :before-close="closeForm"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <industry-child-dialog
      v-if="childDialogVisible"
      :visible.sync="childDialogVisible"
      :parent-row="childParentRow"
      @changed="refreshList"
    ></industry-child-dialog>
  </div>
</template>

<script>
import IndustryList from "./IndustryList.vue";
import IndustryChildDialog from "./IndustryChildDialog.vue";

export default {
  components: {
    IndustryList,
    IndustryChildDialog,
  },
  data() {
    return {
      formVisible: false,
      childDialogVisible: false,
      childParentRow: null,
      form: {
        id: "",
        pid: 0,
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    refreshList() {
      this.$refs.industryList && this.$refs.industryList.refresh();
    },
    openAddForm() {
      this.form = { id: "", pid: 0, name: "" };
      this.formVisible = true;
    },
    openEditForm(row) {
      this.form = {
        id: row.id,
        pid: row.pid,
        name: row.name,
      };
      this.formVisible = true;
    },
    openChildDialog(row) {
      this.childParentRow = row;
      this.childDialogVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        const url = this.form.id
          ? "/api/shop_industry/edit"
          : "/api/shop_industry/add";
        this.$axios.post(url, this.$qs.stringify(this.form)).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.closeForm();
            this.refreshList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    closeForm() {
      this.form = { id: "", pid: 0, name: "" };
      this.formVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopIndustry/index.vue